
/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import { loadModules } from "@/api/moduleRegistry";

// Kick off the module registry fetch as early as possible so router guards
// have a populated map by the time the first navigation resolves.
loadModules().catch(() => {});

const app = createApp(App);
app.use(router)
app.mount("#app");
